import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import * as actionCreators from 'actions/conversation';
import { Button } from '@material-ui/core';

const FileMessage = ({ hideLink, msg, name }) => {
  const dispatch = useDispatch();

  const fetchConversationFile = (p) => dispatch(actionCreators.fetchConversationFile(p));

  return (
    <>
      {name} <FormattedMessage id="msg.file" defaultMessage="uploaded a file" />{' '}
      {!hideLink && (
        <Button
          size="small"
          color="primary"
          onClick={() =>
            fetchConversationFile({
              conversationId: msg.conversation_id,
              resourceId: msg.resource_id,
            })
          }
        >
          [<FormattedMessage id="msg.linkToFile" defaultMessage="link to file" />]
        </Button>
      )}
    </>
  );
};

FileMessage.propTypes = {
  hideLink: PropTypes.bool,
  msg: PropTypes.shape({
    conversation_id: PropTypes.number,
    resource_id: PropTypes.number,
  }).isRequired,
  name: PropTypes.node.isRequired,
};

export default FileMessage;
